export const DATA_PROTECTION_PDF = '/static/data-protection.pdf'

export const PATIENT_INFORMATION_PATH = '/datenschutzerklaerung/patienteninformation'

export const DATA_PROTECTION_PATH = '/datenschutzerklaerung'
